import { NgModule } from '@angular/core';

// #region all modules
import { BixiDefaultLayoutModule } from '@bixi/layout/default-layout';

const MODULES = [BixiDefaultLayoutModule];

@NgModule({
  exports: MODULES
})
export class BixiLayoutModule {
}
